import { cn } from "@/lib/utils";

export type IconShellScale = "kpi" | "search" | "compact";
export type IconShellSemantic =
  | "requests"
  | "tasks"
  | "finance"
  | "pages"
  | "actions"
  | "neutral";

const scaleClasses: Record<IconShellScale, { shell: string; icon: string }> = {
  kpi: { shell: "h-10 w-10 rounded-xl", icon: "h-5 w-5" },
  search: { shell: "h-9 w-9 rounded-xl", icon: "h-[1.125rem] w-[1.125rem]" },
  compact: { shell: "h-7 w-7 rounded-lg", icon: "h-3.5 w-3.5" },
};

const semanticClasses: Record<IconShellSemantic, string> = {
  requests: "icon-shell-requests",
  tasks: "icon-shell-tasks",
  finance: "icon-shell-finance",
  pages: "icon-shell-pages",
  actions: "icon-shell-actions",
  neutral: "icon-shell-neutral",
};

export function getIconShellClasses({
  semantic,
  scale = "search",
  selected = false,
  className,
}: {
  semantic: IconShellSemantic;
  scale?: IconShellScale;
  selected?: boolean;
  className?: string;
}) {
  return cn(
    "icon-shell inline-flex shrink-0 items-center justify-center transition-all duration-200",
    scaleClasses[scale].shell,
    selected ? "icon-shell-selected" : semanticClasses[semantic],
    className,
  );
}

export function getIconGlyphClasses(scale: IconShellScale = "search") {
  return scaleClasses[scale].icon;
}
